export default __webpack_public_path__ + "static/media/area-27.9b54a002.jpg";